import React from "react";

import { OrderResultsContextProvider } from "./context/order-results-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersResultsPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderResultsContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderResultsContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersResultsPage;
